import {makeAutoObservable} from 'mobx';
import {BosUploader} from '@/utils/bos-sdk';

class UploadStateStore {
    isUploading = false;
    private _currentUploader: BosUploader | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    startUpload(uploader: BosUploader) {
        this.isUploading = true;
        this._currentUploader = uploader;
    }

    finishUpload() {
        this.isUploading = false;
        this._currentUploader = null;
    }

    abortUpload() {
        this._currentUploader?.abort();
        this.isUploading = false;
        this._currentUploader = null;
    }
}

export const uploadStateStore = new UploadStateStore();
